import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PostmethodService } from '../../app-config/postmethod.service';

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  constructor(private ws: PostmethodService) { }


  createRegion(request: any) {
    return this.ws.wsPost(request, environment.baseUrl + "masters/region");
  }

  updateRegion(request: any, id:any) {
    return this.ws.wsPut(request, environment.baseUrl + "masters/region", id);
  }

  getRegion() {
    return this.ws.wsGet(environment.baseUrl + "masters/region");
  }

  getCountry() {
    return this.ws.wsGet(environment.baseUrl + "masters/countries");
  }

  getZoneByCountry(id:any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-zones-by-country", id);
  }

  getStateByZone(id:any) {
    return this.ws.wsGetById(environment.baseUrl + "common/get-states-by-zone", id);
  }
}
